import { ColumnType } from "query/ColumnType";

export default class TableColumn {
    public name: string;
    public children: TableColumn[]; 
    public hidden: boolean = false;

    /* Whether this sub-column can have multiple children for each parent column.
       This column can be primitive or a parent. */
    public collection: boolean = false; 

    private _type: ColumnType;
    // In the future, more metadata will be here, such as:
    // * Whether to show this column by default
    // * Sorted by default
    // * Readonly
    // * Required ("is not null")
    // * Validation rules
    // * Description
    // * For <select>, where the options are. (I need a subclass)

    constructor(name: string, type: ColumnType) {
        this.name = name;
        this._type = type;
        this.children = []
    }

    get isComplex() {
        return this.children.length > 0;
    }

    find : (f: (each: TableColumn) => boolean) => TableColumn|undefined 
        = (f) => {
        return this.children.find(f);
    }

    findColumn = (name : String) => {
        for (let each of this.children) {
            if (name === each.name) {
                return each;
            }
        }
        return null;
    }

    get type() {
        return this._type;
    }

    set type(t : ColumnType) {
        this._type = t;
    }
}